export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:title","content":"Rail Monsters | Search, Compare and Buy Train Tickets Online"},{"name":"twitter:title","content":"Rail Monsters | Search, Compare and Buy Train Tickets Online"},{"name":"description","content":"Rail Monsters - Your one-stop destination to buy wordlwide train tickets online ✓ Save with our discounts ✓ Search & Compare Train Tickets ✓ Get the app for booking"},{"property":"og:description","content":"Rail Monsters - Your one-stop destination to buy wordlwide train tickets online ✓ Save with our discounts ✓ Search & Compare Train Tickets ✓ Get the app for booking"},{"name":"twitter:description","content":"Rail Monsters - Your one-stop destination to buy wordlwide train tickets online ✓ Save with our discounts ✓ Search & Compare Train Tickets ✓ Get the app for booking"},{"property":"og:image","content":"https://railmonsters.com/share.png"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Rail Monsters"},{"name":"twitter:image","content":"https://railmonsters.com/share.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"facebook-domain-verification","content":"pf1i79o0rh7gdfadqvsqmvbjyprpg3"},{"name":"apple-itunes-app","content":"app-id=6472889448, app-argument=https://apps.apple.com/us/app/rail-monsters-train-tickets/id6472889448"},{"name":"application-name","content":"Rail Monsters"},{"name":"msapplication-TileColor","content":"#5B00CE"},{"name":"msapplication-TileImage","content":"https://railmonsters.com/mstile-144x144.png"},{"name":"msapplication-square70x70logo","content":"https://railmonsters.com/mstile-70x70.png"},{"name":"msapplication-square150x150logo","content":"https://railmonsters.com/mstile-150x150.png"},{"name":"msapplication-wide310x150logo","content":"https://railmonsters.com/mstile-310x150.png"},{"name":"msapplication-square310x310logo","content":"https://railmonsters.com/mstile-310x310.png"}],"link":[{"rel":"apple-touch-icon-precomposed","sizes":"57x57","href":"https://railmonsters.com/apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"https://railmonsters.com/apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"https://railmonsters.com/apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"https://railmonsters.com/apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon-precomposed","sizes":"60x60","href":"https://railmonsters.com/apple-touch-icon-60x60.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"https://railmonsters.com/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon-precomposed","sizes":"76x76","href":"https://railmonsters.com/apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon-precomposed","sizes":"152x152","href":"https://railmonsters.com/apple-touch-icon-152x152.png"},{"rel":"icon","type":"image/png","sizes":"196x196","href":"https://railmonsters.com/favicon-196x196.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://railmonsters.com/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://railmonsters.com/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://railmonsters.com/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"128x128","href":"https://railmonsters.com/favicon-128.png"},{"rel":"icon","type":"image/x-icon","href":"https://railmonsters.com/favicon.ico"},{"rel":"shortcut icon","type":"image/x-icon","href":"https://railmonsters.com/favicon.ico"},{"rel":"manifest","href":"/manifest.json"},{"rel":"preload","as":"style","onload":"this.rel='stylesheet'","href":"https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300..700&display=swap"}],"style":[],"script":[],"noscript":[],"title":"Rail Monsters | Search, Compare and Buy Train Tickets Online"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false